import { render, staticRenderFns } from "./BMICount.vue?vue&type=template&id=2447150d&scoped=true&"
import script from "./BMICount.vue?vue&type=script&lang=js&"
export * from "./BMICount.vue?vue&type=script&lang=js&"
import style0 from "./BMICount.vue?vue&type=style&index=0&id=2447150d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447150d",
  null
  
)

export default component.exports